/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { GoogleRpcStatus, V2beta1Filter } from '../models/index';
import {
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusToJSON,
  V2beta1FilterFromJSON,
  V2beta1FilterToJSON,
} from '../models/index';

/**
 *
 */
export class DummyFilterServiceApi extends runtime.BaseAPI {
  /**
   */
  async getFilterRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V2beta1Filter>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/apis/v2beta1/filters`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => V2beta1FilterFromJSON(jsonValue));
  }

  /**
   */
  async getFilter(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V2beta1Filter> {
    const response = await this.getFilterRaw(initOverrides);
    return await response.value();
  }
}
